//AuthenticationExternal
export type ParamsDataAuthenticationExternal = {
    tokenExternal: string;
    expiresExternal: string;
    timeExpiresExternal: string;
};

//Authentication
export type ParamsBodyAuthentication = {
    usuario: string;
    password: string;
};

export type ParamsErrorLogin = {
    isError: boolean;
    login: string;
    password: string
};

export type ParamsResponseAuthentication = {
    access_token: string;
    expires_in: string;
};

//recover login

export type ParamsDataUserFound = {
    userFound: boolean;
    obtainUserLogin?: boolean;
    userLogin?: string;
    Frotista?: boolean;
    UsuarioCadastrado?: boolean;
    UsuarioEncontrado?: boolean;
};

export type ParamsBodyValidateDocument = {
    document: string;
};

export type ParamsDataValidateDocument = {
    Frotista: boolean;
    UsuarioCadastrado: boolean;
    UsuarioEncontrado: boolean;
};

export type ParamsBodyObtainUserLogin = {
    document: string;
    plate: string;
    chassi: string;
    zipCode: string;
};

//recover password
export type ParamsDataUserAccountPassword = {
    cdPerson: number;
    cdPersonPhone: number;
    contactsInformation: boolean;
    email: string;
    hasEmail: boolean;
    phoneDDD: string;
    phoneNumber: string;
    phoneType: number;
};

export type ParamsBodyPostSendToken = {
    CdPerson: number;
    ContatoClienteEnum: number;
    PhoneId: number;
    SendToEmail: boolean;
};

export type ParamsBodyPostValidatePasswordToken = {
    CdPerson: number;
    Token: string;
};

export type ParamsBodyPostUpdatePassword = {
    PersonId: number;
    Token: string;
    confirmPassword: string;
    password: string;
};

//first access
export type ParamsBodyPostCreateLoginApp = {
    Alias: string;
    Zipcode: string;
    Plate: string;
    Chassi: string;
    Document: string;
    Email: string;
    Password: string;
    ConfirmPassword: string;
    Token: string;
};

//home
export type ParamsServicesPlatforms = {
    NR_PLATAFORMA: number;
    CD_TIPO_PLATAFORMA: number;
    NM_MODELO_BASICO: string;
    MODELO: string;
    MARCA: string;
    MODELO_ANO: number;
    PLACA: string;
    CHASSI: string;
    COR: string;
    CD_PESSOA: number;
    CD_PESSOA_BENEFICIARIO: number;
    CD_PESSOA_PARCEIRO: number;
    CD_PESSOA_PARCEIRO_ESTABELECIMENTO: number;
    CD_PESSOA_VENDEDOR: number;
    CD_PEDIDO: number;
    CD_PRODUTO: number;
    PRODUTO: string;
    NR_TIPO_PRODUTO: number;
    ATIVO: boolean;
    CD_PEDIDO_ITEM: number;
    NR_PORCENTAGEM_INDENIZACAO: number;
    CODIGO_SEGURADORA: number;
    NOME_SEGURADORA: string;
    EMAIL: string;
    POCSAG: string;
    CD_MODELO: number;
    EVENTO_REAL: boolean;
    LOCALIZACAO: boolean;
    HISTORICO_LOCALIZACAO: boolean;
    COMODATO: boolean;
    FL_CONSULTA_PLACA: boolean;
    CLIENTE_COM_PERFIL: boolean;
    FL_ICS_LIGHT: boolean;
    FL_ITURAN_ONE: boolean;
    FL_ELEGIVEL_PLATINUM: boolean;
    DS_APOLICE: string;
    NR_CNPJ_CPF: string;
    CD_SEGMENTO: number;
    CD_SEGMENTO_CLIENTE: number;
    TECNOLOGIA: number;
    NOME_CLIENTE: string;
    NOME_CLIENTE_ABREVIADO: string;
    APELIDO_CLIENTE: string;
};

export type ParamsCustomerCars = {
    MARCA: string;
    COR: string;
    EMAIL: string;
    PLACA: string;
    POCSAG: string;
    ATIVO: boolean;
    CHASSI: string;
    MODELO: string;
    PRODUTO: string;
    CD_PEDIDO: number;
    CD_PESSOA: number;
    TECNOLOGIA: number;
    CD_PRODUTO: number;
    MODELO_ANO: number;
    NR_CNPJ_CPF: string;
    CD_SEGMENTO: number;
    CD_SEGMENTO_CLIENTE: number;
    NR_PLATAFORMA: number;
    NR_TIPO_PRODUTO: number;
    NM_MODELO_BASICO: string;
    CD_PESSOA_PARCEIRO: number;
    COMODATO: boolean;
    CD_MODELO: number;
    FL_CONSULTA_PLACA: boolean;
    CD_PESSOA_BENEFICIARIO: number;
    NOME_CLIENTE_ABREVIADO: string;
    NOME_CLIENTE: string;
    NR_PORCENTAGEM_INDENIZACAO: number;
    CODIGO_SEGURADORA: number;
    CD_PESSOA_VENDEDOR: number;
    CD_PESSOA_PARCEIRO_ESTABELECIMENTO: number;
    FL_ICS_LIGHT: boolean;
    FL_ITURAN_ONE: boolean;
    FL_ELEGIVEL_PLATINUM: boolean;
    CD_TIPO_PLATAFORMA: number;
};

export type ParamsPersonalCardByPlatform = {
    platformId: number;
    plate: string;
    chassis: string;
    modelName: string;
    policyDescription: string;
    personName: string;
    personDocument: string;
    EmergencyPhone: string;
    SACPhoneSP: string;
    SACPhoneOthers: string;
    policyNumber: string;
};

export type ParamsBodySavePhoto = {
    foto: string;
};

export type ParamsBodyGetVirtualFencesHistory = {
    PocSag: string;
    DtInicio: string;
    DtFim: string;
    Ativa: boolean;
};

export type ParamsDataGetVirtualFencesHistory = {
    IdCerca: number;
    PocSag: string;
    CdPessoaBeneficiario: number;
    RaioMetros: number;
    Latitude: number;
    Longitude: number;
    TempoCercaHoras: number;
    DtCercaIniciada: string;
    CercaAtiva: boolean;
    AlertaWs: boolean;
    Coleta: boolean;
    LatitudeSaida: number;
    LongitudeSaida: number;
};

//Payment
export type ParamsCustomerCharges = {
    CurrentPaymentMethod: string;
    Description: string;
    Invoices: Array<ParamsInvoice>;
};

export type ParamsInvoice = {
    Bank: string;
    BankPortfolio: string;
    CdCobranca: number;
    CdCobrancaAreaCliente?: number;
    Company: string;
    DueDate: string;
    EmpFil: number;
    InscMunicipalNumber: string;
    NFENumber: number;
    NFEVerificationNumber: string;
    NrPlataforma: number;
    Number: number;
    OmegaId: number;
    OriginValue: string;
    PayValue: string;
    PaymentId: number;
    PaymentMethod: string;
    PaymentMethodTypeId: number;
    Plate: string;
    Series: string;
    Service: string;
    Sequence: string;
    Status: string;
    TaxReceipt: string;
    PaymentMethodId: number;
    PaymentMethodName: string;
    PaymentMethodBankNumber: string;
};

export type ParamsPaymentForms = {
    FuturePaymentFormId: null;
    FuturePaymentFormName: null;
    Id: number;
    ModelName: string;
    CD_COBRANCA: number;
    NR_DIA_VENCIMENTO: number;
    NR_TIPO_FIM: null
    PaymentFormId: number;
    PaymentFormName: string;
    PaymentFormTypeId: number;
    PaymentFormTypeName: string;
    Plate: string;
};

export type ParamsPaymentFormsInitial = {
    Id: number;
    InvoiceClosed: number;
    ModelName: string;
    PaymentFormId: number;
    PaymentFormName: string;
    PaymentFormTypeId: number;
    PaymentFormTypeName: string;
    Plate: string;
};

export type ParamsBank = {
    BankNumber: string;
    Name: string;
    PaymentId: number;
    PaymentTypeId: number;
};

export type ParamsChangePaymentMethod = {
    CreditCard: {
        Name: string;
        Number: string;
        ExpirationMonth: string;
        ExpirationYear: string;
        Parcels: string;
    };
    BankAccount: {
        FirstName: string;
        LastName: string;
        CpfNumber: string;
        BankCode: string;
        AgencyCode: string;
        OperationNumber: number;
        AccountNumber: string;
        AccountDigit: string;
    };
    CustomerUser: string;
    PlatformId: number;
    PaymentMethodTypeId: number;
    PaymentMethodId: number;
    CommunicationTypeId: number;
};

export type ParamsBodyChangeBillingPaymentMethod = {
    BankAccount: {
        FirstName: string;
        LastName: string;
        CpfNumber: string;
        BankCode: string;
        AgencyCode: string;
        OperationNumber: number | null;
        AccountNumber: string;
        AccountDigit: string;
    };
    NrPlataforma: number;
    PaymentMethodTypeId: number;
    PaymentMethodId: number;
};

export type ParamsBodyChangeBillingPaymentDueDate = {
    NrPlataforma: number;
    PaymentDueDate: number;
};

export type ParamsBodyPaymentSlipApp = {
    CustomerOmegaId: number;
    Bank: number;
    BankPortifolio: number;
    EmpFil: number;
    EmpFilList: [
        0
    ];
    Number: number;
    Series: string;
    PaymentId: number;
    CustomerUser: string;
    SqDup: string;
    CdCobranca: number;
    CdCobrancaList: [
        0
    ];
    SourceTypePayment: number;
    Nr_Plataforma: number;
    CdPessoa: number;
};

export type ParamsBodyFinancialPending = {
    CPF_CNPJ: string;
    ID_MOTIVO: number;
    DS_PLACA: string | null;
    CD_PARCEIRO: number;
    ZERO_KM?: boolean;
    TokenRecaptcha?: string;
    FL_PAGAS?: boolean;
};

export type ParamsBodyAcceptTerm = {
    CdPerson: number;
    Accept: boolean;
    TypeContractModel: number;
    CdContractModel?: number | null;
};

export type ParamsDataFinancialPending = {
    CD_COBRANCA: number;
    CD_FORMA_PAGAMENTO: number;
    CD_TIPO_COBRANCA: number;
    CHAVE_PAGAMENTO: string;
    COD_VERIF_NFE: string;
    DS_PLACA: string;
    NM_PRODUTO: string;
    DT_EMISSAO: string;
    DT_VENCIMENTO: string;
    EMPRESA: number;
    EMPRESA_LIST: []
    FL_FATURAMENTO_MANUAL: false
    FL_PODE_PARCELAR: false
    ID_FORMA_PGTO: number;
    JUROS: string;
    MULTA: string;
    NM_COBRANCA: string;
    NM_EMPRESA: string;
    NM_FORMA_PGTO: string;
    NM_TIPO_COBRANCA: string;
    NR_INSC_MUN: string;
    NR_PORCENTAGEM_DESCONTO: number;
    NUMERO: string;
    NUM_NFE: string;
    SERIE: string;
    SQ_DUP: string;
    NR_STATUS: number;
    VL_ATUALIZADO: string;
    VL_ORIGINAL: string;
    DT_PERIDO_FIM: string;
    DT_PERIODO_INICIO: string;
};

export type ParamsGenerateBilling = {
    CD_FORMA_PAGAMENTO: number;
    CHAVE_PAGAMENTO: string;
    EMAIL?: string;
};

export type ParamsValidateSolicitationDate = {
    CD_TIPO_OCORRENCIA: number;
    NR_PLATAFORMA: number;
};

export type ParamsDataValidateSolicitationDate = {
    DataUltimaAlteracao: string;
    PermiteAlteracao: boolean;
};

export type ParamsDataGenerateBillingTicket = {
    CdCobranca: number;
    Digitavel: string;
    EmailEnviado: boolean;
    EmpFil: number;
    Html: string;
    Pdf: string;
    IsError: boolean;
};

export type ParamsDataGenerateBillingPix = {
    CdCobranca: number;
    EmailEnviado: boolean;
    EmpFil: number;
    PixQrCode: string;
    PixQrCodeBase64: string;
    IsError: boolean;
};

export type ParamsDataGenerateBillingDefault = {
    CdCobranca: number;
    Digitavel: string;
    EmailEnviado: boolean;
    EmpFil: number;
    Html: string;
    Pdf: string;
    PixQrCode: string;
    PixQrCodeBase64: string;
    IsError: boolean;
};

export type ParamsBodyListarFormaPagamentoPorCanalVenda = {
    CdCanalVenda: number;
    CdTipoCobranca: number;
};

export type ParamsDataListarFormaPagamentoPorCanalVenda = {
    CD_FORMA_PAGAMENTO: number;
    CD_TIPO_COBRANCA: number;
    NM_BANCO: string;
};

export type ParamsBodyGerarCobranca = {
    CARTAO_CREDITO: {
        CODIGO_SEGURANCA: string;
        NM_NOME: string;
        NR_ANO_VALIDADE: string;
        NR_MES_VALIDADE: string;
        NR_NUMERO: string;
        NR_PARCELAS: number;
    }
    CD_FORMA_PAGAMENTO: number;
    CHAVE_PAGAMENTO: string;
    EMAIL: string;
    validade_cartao: string;
};

export type ParamsDataGerarCobranca = {
    cdPagamento: number;
    codigo: number;
    mensagem: string;
};

//my vehicles
export type ParamsDataUsefulContacts = {
    DisplayContactsEnum: number;
    IturanServicosContatos: Array<ParamsDataServicesContacts>;
    ServicosPlataforma: Array<ParamsDataServicesPlatform>;
    ServicosAdicionaisContatos: Array<ParamsDataAdditionalServicesContacts>;
};

export type ParamsDataServicesContacts = {
    Assunto: string;
    LigacoesLocais: string;
    DemaisRegioes: string;
    TodasRegioes: string;
    AssuntoContatoEnum: number;
};

export type ParamsDataServicesPlatform = {
    NR_PLATAFORMA: number;
    CODIGO_SEGURADORA: number;
    NOME_SEGURADORA: string;
    NM_MODELO_BASICO: string;
    DS_PLACA: string;
    SITE: string;
    ExibicaoContatoEnum: number;
    ContatosAssistencia: Array<ParamsDataServicesContacts>;
    ContatosCorretor: ParamsDataContactBroker;
};

export type ParamsDataContactBroker = {
    Nome: string;
    Email: string;
    Telefone: string;
    Celular: string;
};

export type ParamsDataAdditionalServicesContacts = {
    CdProduto: number;
    Contato: string;
    Descricao: string;
    Link: string;
    NomeServico: string;
    NrPLataforma: number;
    Prestadora: string;
};

export type ParamsBodyUpdatePlate = {
    PlatformId: number;
    PadraoMercosul: boolean;
};

export type ParamsDataUpdatePlate = {
    isSuccess: boolean;
    msg: string;
};

// my perfil

export type ParamsDataCustomerForEdit = {
    addressList: Array<ParamsAddressList>;
    allowChangeAddress: boolean;
    birthDate: string;
    customerType: number;
    document: string;
    email: string;
    emergencyList: Array<ParamsEmergencyList>;
    id: number;
    name: string;
    phoneList: Array<ParamsPhoneList>;
    user: { username: string; }
};

export type ParamsAddressList = {
    addressType: number;
    city: string;
    cityId: number;
    collection: boolean;
    deleted: boolean;
    district: string;
    id: number;
    isCEPPernoite: boolean;
    number: number;
    complement: string;
    revenue: boolean;
    startDate: string;
    state: string;
    street: string;
    zipcode: string;
};

export type ParamsEmergencyList = {
    contact: string;
    customerPhoneId: number;
    degreeRelationship: number;
    deleted: boolean;
    number: string;
    phoneDDD: string;
    phoneTypeId: number;
};

export type ParamsPhoneList = {
    customerPhoneId: number;
    deleted: boolean;
    number: string;
    phoneDDD: string;
    phoneTypeId: number;
};

export type ParamsDataPerfilUser = {
    NOME_COMPLETO: string;
    DOCUMENTO: string;
    EMAIL: string;
    PLACA: string;
    UTILIZACAO_VEICULO: string;
    SEXO: string;
    DT_NASCIMENTO: string;
    ESTADO_CIVIL: string;
    BLINDADO: string;
    ISENTO_IMPOSTOS: string;
    ZERO_KM: string;
    CONDUTOR_MENOR_26: string;
    ISENCAO_IMPOSTO: string;
    TRANSPORTE_TRABALHO: string;
    GARAGEM_FECHADA: string;
    GARAGEM_RESIDENCIA: string;
    SEGURADO_PRINCIPAL_CONDUTOR: string;
    SAIDA_CONCESSIONARIA: string;
    MOTIVO_ISENCAO_FISCAL: string;
    SEGURADO_PROPRIETARIO_LEGAL: string;
    NOME_CONDUTOR: string;
    CPF_CONDUTOR: string;
    DATA_NASCIMENTO_CONDUTOR: string;
    SEXO_CONDUTOR: string;
    GARAGEM_FACULDADE: string;
    GARAGEM_TRABALHO: string;
    TEMPO_HABILITACAO: string;
    VINCULO_CONDUTOR_SEGURADO: string;
    ESTADO_CIVIL_CONDUTOR: string;
    CEP_PERNOITE: string;
    VEICULO_KIT_GAS: string;
    NR_VERSAO_PERFIL: number;
    VEICULO_MODIFICADO: string;
    VEICULO_BLINDADO: string;
    VEICULO_TUNADO: string;
    VEICULO_REBAIXADO: string;
    TIPO_VEICULO: string;
    ATIVIDADE_VEICULO: string;
};

export type ParamsBodyEditCustomerAppData = {
    id: number;
    email: string;
    name: string;
    userAlias: string;
    document: string;
    birthDate: string;
};

export type ParamsBodyEditCustomerAppAccess = {
    username: string;
    password?: string;
    confirmPassword?: string;
};

export type ParamsBodyEditCustomerAppPhone = {
    id: number;
    phoneList: Array<{
        customerPhoneId?: number;
        phoneTypeId: number;
        phoneDDD: string;
        number: string;
        deleted?: boolean;
    }>
};

export type ParamsBodyByZipCode = {
    cep: string;
    cityId: number;
    cityName: string;
    district: string;
    fullAddress: string;
    isGeneralZip: boolean;
    shortAddress: string;
    stateName: string;
    type: string;
    indexId?: number;
};

export type ParamsBodyEditCustomerAppAddress = {
    id: number;
    flAtualizaPerfil: boolean;
    addressList: Array<{
        addressType: number;
        city: string;
        cityId: number;
        collection: boolean;
        deleted: boolean;
        district: string;
        id: number;
        isCEPPernoite: boolean;
        number: number;
        revenue: boolean;
        startDate: string;
        state: string;
        street: string;
        zipcode: string;
    }>;
};

export type ParamsDataGetRelationship = {
    CD_GRAU_RELACIONAMENTO: number;
    NM_GRAU_RELACIONAMENTO: string;
};

export type ParamsBodyEditCustomerAppEmergencyContacts = {
    id: number;
    emergencyList: Array<
        {
            number: string;
            contact: string;
            phoneDDD: string;
            deleted: boolean;
            phoneTypeId: number;
            customerPhoneId: number;
            degreeRelationship: number;
        }>;
};

export type ParamsDataPlatformsWithPolicy = {
    allowPolicySending: boolean;
    insurerId: number;
    insurerName: string;
    insurerUrl: string;
    modelName: string;
    plate: string;
    platformId: number;
    policyId: number;
};

export type ParamsBodyPolicyPdfRequest = {
    CdPerson: number;
    Email: string;
    FlSendEmail: boolean;
    OrderId: number;
};

export type ParamsDataPolicyPdfRequest = {
    Data: string | null;
    IsSuccess: boolean;
    Messages: [
        {
            Description: string;
            CodeLevel: string;
        }
    ],
    ErrorCode: any;
};

//sac
export type ParamsDataCustomerForRequest = {
    Documento: string;
    Email: string;
    FaleConoscoOcorrencias: Array<ParamsOcorrenciaOuvidoriaAppFaleConoscoOcorrencias>;
    Nome: string;
    OcorrenciaOuvidoriaApp: Array<ParamsOcorrenciaOuvidoriaAppFaleConoscoOcorrencias>;
    Telefones: Array<ParamsOcorrenciaOuvidoriaApp>;
};

export type ParamsOcorrenciaOuvidoriaAppFaleConoscoOcorrencias = {
    CD_TIPO_OCORRENCIA: string;
    GrupoOcorrenciaEnum: number;
    NM_TIPO_OCORRENCIA: string;
};

export type ParamsOcorrenciaOuvidoriaApp = {
    D_PESSOA_TELEFONE: number;
    CD_TIPO_TELEFONE: number;
    NR_DDD: string;
    NR_TELEFONE: string;
};

export type ParamsDataFaq = {
    answer: string;
    answerVisible: boolean;
    id: number;
    question: string;
    relevance: number;
};

export type ParamsBodyFormFaleConosco = {
    corporateNumberOrFisicalNumber: string;
    email: string;
    message: string;
    name: string;
    organicSource: string;
    phone: string;
    source: string;
    subject: string;
};

//scheduling
export type ParamsBodyGetListStoresByZipCode = {
    CD_PEDIDO: number;
    NR_CEP_AGENDAMENTO: string;
    FL_DOMICILIAR: boolean;
    NR_TIPO_AGENDAMENTO: number;
    DT_INICIO?: string;
    DT_VALIDADE_COTACAO?: string;
};

export type ParamsDataOrdersByCustomerId = {
    CD_AGENDAMENTO: number;
    DT_INICIO: string;
    NR_TIPO_AGENDAMENTO: number;
    NR_STATUS: number;
    DS_STATUS: string;
    DS_CHASSI: string;
    DS_TIPO_AGENDAMENTO: string;
    NM_PRODUTO: string;
    CD_PEDIDO: number;
    DATA_PEDIDO: string;
    CD_SOLICITACAO: number;
    CD_SOLICITACAO_AGENDAMENTO: number;
    NM_LOJA: string;
    NM_FANTASIA_LOJA: string;
    NR_PLATAFORMA: number;
    DS_PLACA: string;
    CD_COTACAO: number;
    FL_RESCHEDULING: boolean;
    CD_COBRANCA_TAXA_REAGENDAMENTO: number;
    DT_FIM: string;
    NM_ENDERECO: string;
    CD_TIPO_LOGRADOURO: string;
    NR_NUMERO: number;
    NM_BAIRRO: string;
    NM_CIDADE: string;
    CD_UF: string;
};

export type ParamsDataOrderDetailScheduling = {
    CD_AGENDAMENTO: number;
    CD_SOLICITACAO: number;
    CD_PEDIDO: number;
    CD_PEDIDO_ITEM: number;
    CD_SEGMENTO: number;
    DS_PLACA: string;
    DT_CRIACAO: string;
    DT_INICIO: string;
    DT_VALIDADE_COTACAO: string;
    FL_DOMICILIAR: boolean;
    NM_MODELO: string;
    NM_PESSOA_BENEFICIARIO: string;
    NR_CEP_AGENDAMENTO: string;
    NR_TIPO_AGENDAMENTO: number;
    TAXA_REAGENDAMENTO: true
    VL_TOTAL: number;
};

export type ParamsDataListStoresByZipCode = {
    DATAS_HORAS: Array<ParamsDateAndHours>;
    LOJA: ParamsStore;
};

export type ParamsDataListStores = {
    CD_LOJA: number;
    CD_UF: string;
    DS_PONTO_REFERENCIA: string;
    NM_BAIRRO: string;
    NM_CIDADE: string;
    NM_ENDERECO: string;
    NOME_LOJA: string;
    NR_CEP: string;
    NR_DISTANCIA: number;
    NR_NUMERO: number;
    Date: string;
    Horarios: Array<{
        DT_HORARIO: string;
        NR_PERIODO: number;
    }>
};

type ParamsStore = {
    CD_LOJA: number;
    CD_UF: string;
    DS_PONTO_REFERENCIA: string;
    NM_BAIRRO: string;
    NM_CIDADE: string;
    NM_ENDERECO: string;
    NOME_LOJA: string;
    NR_CEP: string;
    NR_DISTANCIA: number;
    NR_NUMERO: number;
};

type ParamsDateAndHours = {
    Data: string;
    Horarios: Array<{
        DT_HORARIO: string;
        NR_PERIODO: number;
    }>
};

export type ParamsListStores = {
    date: string;
    NR_CEP: string;
    CD_LOJA: number;
    NOME_LOJA: string;
    DS_PONTO_REFERENCIA: string;
    NR_DISTANCIA: number;
    NM_ENDERECO: string;
    NR_NUMERO: number;
    NM_BAIRRO: string;
    NM_CIDADE: string;
    hours: Array<{
        DT_HORARIO: string;
        NR_PERIODO: number;
    }>;
    isStoreSelected?: (CD_LOJA: number) => void;
    isSelected?: number;
    isIndexStore?: number;
    isExchanges?: boolean;
    isSchedulingUninstall?: boolean;
    CD_PEDIDO?: number;
    NR_PLATAFORMA?: number;
    isWebView: boolean;
    isMaintenance?: boolean;
}

export type ParamsBodyEffectSchedule = {
    CD_PEDIDO: number;
    CD_SOLICITACAO: number;
    NR_TIPO_AGENDAMENTO: number;
    FL_DOMICILIAR: boolean;
    CD_PESSOA_LOJA: number;
    NR_PERIODO: number;
    DT_AGENDAMENTO: string;
    NR_CEP: string;
    NM_ENDERECO: string;
    NR_NUMERO: string;
    DS_COMPLEMENTO: string;
    NM_BAIRRO: string;
    DS_PONTO_REFERENCIA: string;
    NM_CONTATO: string;
    NR_TELEFONE_CONTATO: string;
    CD_SEGMENTO: number;
    FL_TROCA_SERVICO: boolean;
}

export type ParamsDataGenerateReschedulingFee = {
    PDF: string;
    digitavel: string;
    html: string;
    pdf: string;
}

export type ParamsBodyGenerateReschedulingFee = {
    CD_PEDIDO_ITEM: number;
    customerUser: string;
}

//Exchanges

export type FormDataPerfil = {
    name: string;
    email: string;
    phone: string;
    identity: string;
    cep: string;
    sex: { text: string; value: string };
    birthData: string;
    civilStatus: { text: string; value: string };
    chassisOrBoard: string;
}

export type FormDataRegisterValidation = {
    name: string;
    email: string;
    phone: string;
    identity: string;
    sex: { text: string; value: string };
    birthData: string;
    address: FormDataAddress;
}

export type FormDataPersonalDataForm = {
    name: string;
    email: string;
    phone: string;
    identity: string;
    birthData: string;
    chassisOrBoard: string;
}

export type FormDataAddress = {
    cep: string;
    street: string;
    complement: string;
    state: { text: string; value: string };
    city: string;
    district: string;
    houseNumber: string;
    type: string;
}

export type FormDataVehicle = {
    minimumAge: string;
    mainConductor: string;
    licenseTime: string;
    vehicleUse: { text: string; value: string };
    vehicleType: { text: string; value: string };
    vehicleActivity: { text: string; value: string };
    equipped: string;
    vehicleNoModifications: boolean;
    vehicleArmored: boolean;
    vehicleLowered: boolean;
    vehicleTuned: boolean;
    exemptionImpostor: string;
    newCar: string;
    transportToWork: string;
    gasKit: string;
    keptInGarage: string;
    safeOwnerVehicle: string;
    atHome: boolean;
    atWork: string;
    atSchoolOrcollege: string;

    insuredBond?: { text: string; value: string };
    sexConductor?: { text: string; value: string };
    nameConductor?: string;
    identityConductor?: string;
    birthDataConductor?: string;
    civilStatusConductor?: { text: string; value: string };

    departureDealership?: string;
    taxExemptionReason?: { text: string; value: string };

    brands?: string;
    models?: string;
    versions?: string;
    year?: string;
    colors?: string;
    chassisOrBoard?: string;
    yearManufacture?: string
    chassis?: string;

    yearId?: number;
    brandId?: number;
    modelId?: number;
    versionId?: number
}

export type ParamsTypeCharges = {
    CD_TIPO_COBRANCA: number;
    NM_TIPO_COBRANCA: string;
    NR_MESES_RECORRENCIA: number;
    VL_TOTAL: number;
}

export type ParamsPackage = {
    name: string;
    price: number;
    codProduct: number;
    VL_COMISSAO: number;
    nrTypeProduct: number;
    cdQuotationItem: number;
}

export type ParamsBodyPostQuoteListservices = {
    customerId: number;
    CD_PEDIDO: number;
    ceP_PERNOITE: string;
    dS_PERFIL: Array<ParamsDS_PERFIL>;
    nR_VERSAO_PERFIL: number;
}

export type ParamsDsPerfil = {
    zero_km: number;
    veiculo_modificado: number;
    isencao_imposto: number;
    finalidade_uso_veiculo: string;
    nascimento_segurado: string;
    sexo_segurado: string;
    estado_civil_segurado: string;
    tempo_habilitacao: string;
    condutor_menor_26: number;
    transporte_trabalho: number;
    garagem_fechada: number;
    garagem_residencia: number;
    garagem_trabalho: number;
    garagem_faculdade: number;
    segurado_proprietario_legal: number;
    segurado_principal_condutor: number;
    cpf_condutor: string;
    nome_condutor: string;
    data_nascimento_condutor: string;
    sexo_condutor: string;
    estado_civil_condutor: string;
    vinculo_condutor_segurado: string;
    saida_concessionaria: string;
    veiculo_leilao: number;
    veiculo_chassi_remarcado: number;
    veiculo_kit_gas: number;
    motivo_isencao_fiscal: string;
}

export type ParamsDataPostQuoteListservices = {
    cD_COTACAO: number;
    guiD_COTACAO: string;
    nM_LEAD: string;
    cD_LEAD: string;
    dS_PLACA: string;
    dS_CHASSI: string;
    nR_CPF_CNPJ: string;
    dT_COTACAO: string;
    dT_VALIDADE: string;
    dS_PERFIL: Array<ParamsDS_PERFIL>;
    cotacaO_ITEMS: Array<itemProduct>;
    nR_CEP_PERNOITE: string;
    cD_PESSOA_PARCEIRO: number;
    cD_PESSOA_PARCEIRO_ESTABELECIMENTO: number;
    cD_PESSOA_VENDEDOR: number;
    cD_PESSOA_RESPONSAVEL: number;
    cD_CANAL_VENDA: number;
    cD_TIPO_COMERCIALIZACAO: number;
    nR_ANO: number;
    nR_ANO_FABRICACAO: number;
    porcentageM_IMPOSTO: number;
    fL_COMISSAO_VARIAVEL: boolean;
    cD_MARCA: number;
    nM_MARCA: string;
    cD_MODELO_BASICO: number;
    nM_MODELO_BASICO: string;
    cD_MODELO: number;
    nM_MODELO: string;
    fL_INSTALADO: boolean;
    allow_Sale: boolean;
    nR_TIPO_COTACAO: number;
    formaS_PAGAMENTO: Array<formOfPayment>;
    quotE_URL: string;
    nM_PARCEIRO: string;
    nR_TELEFONE_PARCEIRO: string;
}

export type itemProduct = {
    cD_COTACAO_ITEM: string;
    vL_TOTAL: string;
    vL_ANUAL: string;
    vL_BASE_COMISSAO: number;
    nR_MESES_RECORRENCIA: number;
    nM_PRODUTO: string;
    dS_PRODUTO: Array<string>;
    cD_PRODUTO: number;
    nR_PORCENTAGEM_INDENIZACAO: number;
    fL_ESCOLHIDO: boolean;
    fL_ICS_LIGHT: boolean;
    nR_TIPO_PRODUTO: number;
    nR_ORDENACAO: number;
    vL_COMISSAO_MINIMO: number;
    vL_COMISSAO_MAXIMO: number;
    vL_COMISSAO_ADICIONAL: number;
    vL_FRANQUIA: string;
    fL_OCS: boolean;
    fL_CASCO: boolean;
    taxA_VL_TOTAL: number;
    taxA_MSG: string;
    primeirA_MENSALIDADE_MSG: string;
    produdoS_VINCULADOS: null,
    fL_DOMICILIAR: boolean;
    nR_PESO_ESCOLHA: number;
    produtO_ATUAL: true;
}

export type formOfPayment = {
    cD_TIPO_FORMA_PAGAMENTO: number;
    nR_MESES_RECORRENCIA: number;
    nM_TIPO_FORMA_PAGAMENTO: string;
    formA_PAGAMENTO: Array<
        {
            nM_FORMA_PAGAMENTO: string;
            cD_FORMA_PAGAMENTO: number;
            nR_QTDE_PARCELAS_MAX: number;
        }>;
    nR_PORCENTAGEM_DESCONTO: number;
    fL_PERMITIR_DESCONTO: boolean;
    cD_TIPO_COBRANCA: number;
}

export type handleBodyFormDataPerfil = {
    body: FormDataPerfil;
    sameProfile?: boolean;
    linkNavigate: string;
}

export type ParamsBodyValidateChoose = {
    cD_PEDIDO: number;
    cD_PRODUTO: number;
}

export type ParamsDataValidateChoose = {
    errorCode: null | string;
    message: string;
    success: boolean;
    data: {
        fL_AGENDAMENTO: boolean | null;
        nR_COMPARACAO_TROCA: NR_COMPARACAO_TROCA | null;
        nR_TIPO_PRODUTO: number | null;
    } | null;
}

export enum NR_COMPARACAO_TROCA {
    Incompativel = 1,
    Equivalente = 2,
    Downgrade = 3,
    Upgrade = 4
}

export type ParamsBodyCart = {
    name: string;
    codPlane: number;
    percentageIndem: number;
    price: string;
    cents: string;
    cdQuotationItem: string;
    nrTypeProduct: number;
    cdQuotation?: number;
    VL_COMISSAO: number;
}

export type ParamsBodyPostCreateChangeSolicitation = {
    cD_PESSOA: number;
    cD_PEDIDO: number;
    nR_PLATAFORMA: number;
    nM_PESSOA: string;
    nR_TELEFONE_CONTATO: string;
}

export type ParamsBodyChangeSolicitation = {
    cD_PESSOA: number;
    cD_PEDIDO: number;
    nR_PLATAFORMA: number;
}

export type ParamsBodyPostCancelChange = {
    cD_COTACAO: number;
    cD_PESSOA: number;
    cD_PEDIDO?: number;
}

export type ParamsBodyPostGetStatus = {
    customerId: number;
    cD_PEDIDO: number;
    GUID_COTACAO: string;
}

export type ParamsDataGetPlatformRemoval = {
    CD_PESSOA: number;
    CD_SEGMENTO: number;
    NR_PLATAFORMA: number;
    DS_PLACA: string;
    CD_PEDIDO: number;
    DS_PRODUTO: string;
    NM_PRODUTO: string;
    DS_CHASSI: string;
    FL_NAO_DEVOLUCAO_PROMOCIONAL?: boolean;
    VL_TAXA?: number;
}

export type ParamsDataGetFitClientScheduling = {
    CD_PESSOA: number;
    NR_PLATAFORMA: number;
    DS_PLACA: string;
    CD_PEDIDO: number;
    DS_PRODUTO: string;
    NM_PRODUTO: string;
}

export type ParamsBodyChooseQuoteItems = {
    customerId: number;
    cD_PEDIDO: number;
    cD_COTACAO: number;
    quoteItemsChoose: Array<ParamsQuoteItemsChoose>;
}

export type ParamsDataChooseQuoteItems = {
    nM_CLIENTE: string;
    dS_EMAIL_CLIENTE: string;
    modelo: string;
    marca: string;
    chassi: string;
    nR_CEP_PERNOITE: string;
    placA_CHASSI: string;
    ano: number;
    anofabricacao: number;
    produtos: Array<string>;
    preco: string;
    vL_TOTAL: string;
    vL_FRANQUIA: string;
    vlR_COMISSAO: string;
    idS_TIPOS_FORMA_PAGAMENTO: any;
}

export type ParamsDataProductCart = {
    customerId: number;
    cD_PEDIDO: number;
    cD_COTACAO: number;
    productPlan: ParamsProduct;
    productAdd: Array<ParamsProduct>;
    vL_TOTAL_Cart: string;
}

export type ParamsDataProductCartAddServices = {
    customerId: number;
    cD_PEDIDO: number;
    cD_COTACAO: number;
    productAdd: Array<ParamsProduct>;
    vL_TOTAL_Cart: string;
}

export type ParamsQuoteItemsChoose = {
    cD_COTACAO_ITEM: number;
    cD_PRODUTO: number;
    nR_TIPO_PRODUTO: number;
}

export type ParamsBodyCartState = {
    customerId: number;
    cD_PEDIDO: number;
    cD_COTACAO: number;
}

export type ParamsProduct = {
    cD_COTACAO_ITEM: number;
    cD_PRODUTO: number;
    nR_TIPO_PRODUTO: number;
    nR_PORCENTAGEM_INDENIZACAO: number;
    nM_PRODUTO: string;
    vL_TOTAL: string;
    dS_PRODUTO?: string;
}

export type ParamsBodyConfirmOrder = {
    CD_COTACAO: number;
    GUID_COTACAO: string;
    CD_PEDIDO_TROCA: number;
    FL_DOMICILIAR: boolean;
    DS_EMAIL_PIX: { DS_EMAIL_PIX: string; };
    CONTATO_EMERGENCIA: Array<ParamsEmergencyContact>;
    FORMA_PAGAMENTO_COBRANCAS: Array<ParamsPaymentMethodCharges>;
    FL_AGENDAMENTO: boolean;
}

type ParamsEmergencyContact = {
    GRAU_RELACIONAMENTO: number;
    NM_NOME: string;
    NR_TELEFONE: string;
}

type ParamsPaymentMethodCharges = {
    AGENCIA: string;
    CD_FORMA_PAGAMENTO: string;
    CD_FORMA_PAGAMENTO_BANCO_ESCOLHIDO: number;
    CD_TIPO_FORMA_PAGAMENTO_ESCOLHIDA: number;
    CONTA: string;
    DETALHE_TAXA: Array<ParamsFeeDetails>;
    DIGITO_CONTA: string;
    NM_COBRANCA_SITE: string;
    NR_MESES_RECORRENCIA: number;
    REQUER_AGENDAMENTO: boolean;
    TIPO_COBRANCA: number;
    VL_TOTAL: string;
}

type ParamsFeeDetails = {
    NM_PRODUTO: string;
    CD_PRODUTO: number;
    VL_TOTAL: string;
}

export type ParamsDataConfirmOrder = {
    order: {
        cD_PEDIDO: number;
        cD_COTACAO: number;
        cD_PAGAMENTO: number;
        cD_TIPO_FORMA_PAGAMENTO: number;
        cobrancas: any;
        cD_TIPO_FORMA_PAGAMENTO_TAXA: number;
    };
    payment: { guiD_PAGAMENTO: string; }
    fL_ATENDIMENTO_INICIAL_MANUTENCAO: boolean
}

export type ParamsDS_PERFIL = {
    key: string;
    value: string;
}

export type ParamsDataGetListarCotacoes = {
    CD_CANAL_VENDA: number;
    CD_COTACAO: number;
    CD_LEAD: string;
    CD_MODELO: number;
    CD_PESSOA_MULTICALCULO: number;
    CD_PESSOA_ORIGEM: number;
    CD_PESSOA_PARCEIRO: number;
    CD_PESSOA_PARCEIRO_ESTABELECIMENTO: number;
    CD_PESSOA_RESPONSAVEL: number;
    CD_PESSOA_VENDEDOR: number;
    CD_SISTEMA: number;
    CD_TIPO_COMERCIALIZACAO: number;
    COTACAO_ITEM: {
        cD_COTACAO: number;
        guiD_COTACAO: string;
        nM_LEAD: string;
        cD_LEAD: string;
        dS_PLACA: string;
        dS_CHASSI: string;
        nR_CPF_CNPJ: string;
        dT_COTACAO: string;
        dT_VALIDADE: string;
        dS_PERFIL: Array<ParamsDS_PERFIL>;
        cotacaO_ITEMS: Array<itemProduct>;
        nR_CEP_PERNOITE: string;
        cD_PESSOA_PARCEIRO: number;
        cD_PESSOA_PARCEIRO_ESTABELECIMENTO: number;
        cD_PESSOA_VENDEDOR: number;
        cD_PESSOA_RESPONSAVEL: number;
        cD_CANAL_VENDA: number;
        cD_TIPO_COMERCIALIZACAO: number;
        nR_ANO: number;
        nR_ANO_FABRICACAO: number;
        porcentageM_IMPOSTO: number;
        fL_COMISSAO_VARIAVEL: boolean;
        cD_MARCA: number;
        nM_MARCA: string;
        cD_MODELO_BASICO: number;
        nM_MODELO_BASICO: string;
        cD_MODELO: number;
        nM_MODELO: string;
        fL_INSTALADO: boolean;
        allow_Sale: boolean;
        nR_TIPO_COTACAO: number;
        formaS_PAGAMENTO: Array<formOfPayment>;
        quotE_URL: string;
        nM_PARCEIRO: string;
        nR_TELEFONE_PARCEIRO: string;
    },
    DS_CHASSI: string;
    DS_COMBUSTIVEL: string;
    DS_COR: string;
    DS_PERFIL: string;
    DS_PLACA: string;
    DT_COTACAO: string;
    DT_NASCIMENTO: string;
    DT_VALIDADE: string;
    GUID_COTACAO: string;
    NR_ANO: number;
    NR_ANO_FABRICACAO: number;
    NR_CEP_PERNOITE: string;
    NR_CPF_CNPJ: string;
    NR_PLATAFORMA_ORIGEM: number;
    NR_PORCENTAGEM_COMISSAO: number;
    NR_TIPO_COTACAO: number;
    NR_VERSAO_PERFIL: number;
    STATUS_PEDIDO_COTACAO: number;
    VL_FIPE: number;
}

export type ParamsDataGetStatus = {
    step: number;
    dS_PLACA: string;
    cD_PEDIDO: number;
    cD_PEDIDO_NOVO: number;
    cotacaoPedidoStatus: number;
    fL_AGENDAMENTO: boolean;
    nR_COMPARACAO_TROCA: NR_COMPARACAO_TROCA | null;
    quote: {
        cD_COTACAO: number;
        guiD_COTACAO: string;
        nM_LEAD: string;
        cD_LEAD: string;
        dS_PLACA: string;
        dS_CHASSI: string;
        nR_CPF_CNPJ: string;
        dT_COTACAO: string;
        dT_VALIDADE: string;
        dS_PERFIL: Array<ParamsDS_PERFIL>;
        cotacaO_ITEMS: Array<itemProduct>;
        nR_CEP_PERNOITE: string;
        cD_PESSOA_PARCEIRO: number;
        cD_PESSOA_PARCEIRO_ESTABELECIMENTO: number;
        cD_PESSOA_VENDEDOR: number;
        cD_PESSOA_RESPONSAVEL: number;
        cD_CANAL_VENDA: number;
        cD_TIPO_COMERCIALIZACAO: number;
        nR_ANO: number;
        nR_ANO_FABRICACAO: number;
        porcentageM_IMPOSTO: number;
        fL_COMISSAO_VARIAVEL: boolean;
        cD_MARCA: number;
        nM_MARCA: string;
        cD_MODELO_BASICO: number;
        nM_MODELO_BASICO: string;
        cD_MODELO: number;
        nM_MODELO: string;
        fL_INSTALADO: boolean;
        allow_Sale: boolean;
        nR_TIPO_COTACAO: number;
        formaS_PAGAMENTO: Array<formOfPayment>;
        quotE_URL: string;
        nM_PARCEIRO: string;
        nR_TELEFONE_PARCEIRO: string;
    },
    quoteItemsChooses?: Array<ParamsQuoteItemsChooseStatus>;
    purchaseSummary: {
        nM_CLIENTE: string;
        dS_EMAIL_CLIENTE: string;
        modelo: string;
        marca: string;
        chassi: string;
        nR_CEP_PERNOITE: string;
        placA_CHASSI: string;
        ano: number;
        anofabricacao: number;
        produtos: Array<string>;
        preco: string;
        vL_TOTAL: string;
        vL_FRANQUIA: string;
        vlR_COMISSAO: string;
        idS_TIPOS_FORMA_PAGAMENTO: {
            boleto: Array<number>;
            boletO_ELETRONICO: Array<number>;
            cartao: Array<number>;
            debito: Array<number>;
            pix: Array<number>;
        },
        fL_DOMICILIAR: boolean;
    }
}

export type ParamsBodyPostQuotePlatform = {
    customerId: number;
    cD_PEDIDO: number;
    cD_CANAL_VENDA: number;
    dS_PLACA: string;
    dS_CHASSI: string;
    cD_MODELO: number | null;
    nR_ANO: number | null;
    nR_ANO_FABRICACAO: number | null;
    dS_COMBUSTIVEL: string | null;
    dS_COR: string | null;
    fL_0KM: boolean;
    ceP_PERNOITE: string;
    dS_PERFIL: Array<ParamsDS_PERFIL>;
    nR_VERSAO_PERFIL: number;
}

export type ParamsBodyCreateChangeSolicitationPlatform = {
    cD_PESSOA: number;
    cD_PEDIDO: number;
    nR_PLATAFORMA: number;
    cD_COTACAO: number;
}

export type ParamsBodyPostObterDadosCorretorPorPedido = {
    NR_PLATAFORMA: number;
}

export type ParamsDataPostObterDadosCorretorPorPedido = {
    Celular: string;
    Email: string;
    Nome: string;
    Telefone: string;
}

export type ParamsBodyParseProductCart = {
    customerId: number;
    cD_PEDIDO: number;
    cD_COTACAO: number;
    quoteItemsChooses: Array<ParamsQuoteItemsChooseStatus>;
}

export type ParamsQuoteItemsChooseStatus = {
    cD_COTACAO_ITEM: number;
    cD_PRODUTO: number;
    nR_TIPO_PRODUTO: number;
    nM_PRODUTO: string;
    dS_PRODUTO: string;
    dS_TITULO_SITE: string;
    vL_TOTAL: string;
    nR_PORCENTAGEM_INDENIZACAO: number;
}

export type ParamsPageWebView = {
    isWebView: boolean;
}

export type ParamsUpdatePerfil = {
    type: 'generalData' | 'accessData' | 'phoneContact' | 'billingAddress' | 'emergencyContact' | 'default';
    result: boolean;
    error_msg: string;
    showModal?: boolean;
    flPerfil?: boolean;
}

export type ParamsDataCar = {
    brands?: Array<ParamsBrands>;
    models?: Array<ParamsModels>;
    versions?: Array<ParamsVersions>;
    year?: Array<ParamsYear>;
    colors?: Array<ParamsColors>
}

export type ParamsBrands = {
    NM_MARCA: string;
    CD_MARCA: number
}

export type ParamsModels = {
    NM_MODELO_BASICO: string;
    CD_MODELO_BASICO: number
}

export type ParamsVersions = {
    NM_MODELO: string;
    CD_MODELO: number
}

export type ParamsYear = {
    NR_ANO: number;
    CD_MODELO_ANO: number
}

export type ParamsColors = {
    DS_COR: string
}

export type ParamsPayloadCartDetails = {
    typeDetailsCar: 'brands' | 'models' | 'versions' | 'year' | 'colors';
    codDetailCar: number;
}

export type ParamsVersion = {
    CD_MARCA: number;
    CD_MODELO: number;
    CD_MODELO_BASICO: number;
    DS_CHASSI: string;
    DS_COMBUSTIVEL: string;
    DS_COR: string;
    DS_PLACA: string;
    NM_MARCA: string;
    NM_MODELO: string;
    NM_VERSAO: string;
    NR_ANO: number;
    NR_ANO_FABRICACAO: number;
    NR_MODELO_FIPE: string;
    TIPO_PLATAFORMA: number;
}
//Additional Services
export type ParamsBodyPostCreateQuote = {
    DS_CHASSI: string;
    DS_INSTALACAO: string | null;
    NR_ANO: number;
    NR_ANO_FABRICACAO: number | null;
    CD_TIPO_COMERCIALIZACAO: number;
    DS_PERFIL: (Array<{
        key: string;
        value: string;
    }>) | null;
    SISTEMA_ENUM: number;
    NR_TIPO_COTACAO: number;
    NR_CPF_CNPJ: string;
    DS_PLACA: string;
    NR_CEP_PERNOITE: string | null;
    CD_LEAD: string;
    CD_PESSOA_VENDEDOR: string | null;
    CD_PESSOA_RESPONSAVEL: string;
    CD_PESSOA_PARCEIRO: number;
    CD_PESSOA_PARCEIRO_ESTABELECIMENTO: number;
    CD_CANAL_VENDA: number;
    CD_CANAL_VENDA_PARCEIRO: number | null;
    CD_MODELO: number | null;
    CD_PESSOA_ORIGEM: number;
    NR_PLATAFORMA_ORIGEM: number;
    DS_COR: string;
    DT_NASCIMENTO: string;
    NR_VERSAO_PERFIL: number;
}

export type ParamsDataPostCreateQuote = {
    CD_PEDIDO_NOVO: number;
    DESCONTO_2_PEDIDO: Array<any>;
    NM_LEAD: string;
    CD_LEAD: string;
    DS_PLACA: string;
    DS_CHASSI: string;
    NR_CPF_CNPJ: string;
    CD_COTACAO: number;
    GUID_COTACAO: string;
    DT_COTACAO: string;
    DT_VALIDADE: string;
    COTACAO_ITEMS: Array<ParamsProductServiceAdd>;
    NR_CEP_PERNOITE: string;
    CD_PESSOA_PARCEIRO: number;
    CD_PESSOA_PARCEIRO_ESTABELECIMENTO: number;
    CD_PESSOA_VENDEDOR: number;
    CD_PESSOA_RESPONSAVEL: number;
    CD_CANAL_VENDA: number;
    CD_TIPO_COMERCIALIZACAO: number;
    NR_ANO: number;
    NR_ANO_FABRICACAO: number;
    PORCENTAGEM_IMPOSTO: number;
    FL_COMISSAO_VARIAVEL: boolean;
    CD_MARCA: number;
    NM_MARCA: string;
    CD_MODELO_BASICO: number;
    NM_MODELO_BASICO: string;
    CD_MODELO: number;
    NM_MODELO: string;
    FL_INSTALADO: boolean;
    FORMAS_PAGAMENTO: Array<ParamsFormOfPaymentServiceAdd>;
    Allow_Sale: boolean;
    NR_TIPO_COTACAO: number;
    QUOTE_URL: string;
    STATUS_PEDIDO_COTACAO: number;
}

export type ParamsProductServiceAdd = {
    CD_COTACAO_ITEM: number;
    VL_TOTAL: string;
    VL_ITURAN: number;
    VL_BRUTO_TOTAL: number;
    VL_DESCONTO: number;
    VL_MIN_CAMPANHA: number;
    VL_ANUAL: string;
    VL_BASE_COMISSAO: number;
    NR_MESES_RECORRENCIA: number;
    NM_PRODUTO: string;
    DS_PRODUTO: Array<string>;
    CD_PRODUTO: number;
    NR_PORCENTAGEM_INDENIZACAO: number;
    FL_ESCOLHIDO: boolean;
    NR_TIPO_PRODUTO: number;
    NR_ORDENACAO: number;
    VL_COMISSAO_MINIMO: number;
    VL_COMISSAO_MAXIMO: number;
    VL_COMISSAO_ADICIONAL: number;
    VL_FRANQUIA: string;
    FL_OCS: boolean;
    FL_CASCO: boolean;
    TAXA_VL_TOTAL: number;
    TAXA_MSG: string;
    PRIMEIRA_MENSALIDADE_MSG: string;
    TIPO_COBRANCAS: Array<ParamsTypeCharge>;
    FL_DOMICILIAR: boolean;
    FL_CHAVE_PRESENCA: boolean;
    NR_PESO_ESCOLHA: number;
    CAMPANHAS_ELETIVAS_COTACAO_ITEM: Array<any>;
}

export type ParamsTypeCharge = {
    CD_TIPO_COBRANCA: number;
    NM_TIPO_COBRANCA: string;
    NR_MESES_RECORRENCIA: number;
    VL_DESCONTO_CAMPANHA: number;
    VL_MIN_CAMPANHA: number;
    VL_TOTAL: number;
    VL_TOTAL_APOS_DESCONTO_CAMPANHA: number;
}

export type ParamsFormOfPaymentServiceAdd = {
    CD_TIPO_COBRANCA: number;
    CD_TIPO_FORMA_PAGAMENTO: number;
    FL_PERMITIR_DESCONTO: boolean;
    FORMA_PAGAMENTO: Array<
        {
            CD_FORMA_PAGAMENTO: number;
            NM_FORMA_PAGAMENTO: string;
            NR_QTDE_PARCELAS_MAX: number;
        }>;
    NM_TIPO_FORMA_PAGAMENTO: string;
    NR_MESES_RECORRENCIA: number;
    NR_PORCENTAGEM_DESCONTO: number;
}

export type ParamsBodyPostCreateLead = {
    NM_LEAD: string;
    DS_EMAIL: string;
    NR_TELEFONE: string;
    NM_URL_CRIACAO?: string;
    CD_PESSOA_PARCEIRO_CRIACAO?: number;
    CD_CANAL_VENDA_CRIACAO?: number;
    JS_CONSENTIMENTO?: {
        optin: {
            messaging: boolean;
            voice: boolean;
            email: boolean;
            'social-media': boolean;
        };
    };
}

export type ParamsDataPostCreateLead = {
    CD_LEAD: string;
    COTACAO: Array<any>;
    DS_EMAIL: string;
    DS_ORIGEM: string;
    DT_CRIACAO: string;
    NM_LEAD: string;
    NR_TELEFONE: string;
    NM_URL_CRIACAO?: string;
    CD_PESSOA_PARCEIRO_CRIACAO?: number;
    CD_SISTEMA_CRIACAO?: number;
    CD_CANAL_VENDA_CRIACAO?: number;
}

export type ParamsBodyPostUpdateQuote = {
    cD_COTACAO_ITEM: number;
    cD_PRODUTO: number;
    nR_TIPO_PRODUTO: number;
}

export type ParamsDataPostUpdateQuote = {
    NM_CLIENTE: string;
    DS_EMAIL_CLIENTE: string;
    MODELO: string;
    MARCA: string;
    CHASSI: string;
    NR_CEP_PERNOITE: string;
    PLACA_CHASSI: string;
    ANO: number;
    ANOFABRICACAO: number;
    PRODUTOS: Array<string>;
    PRECO: string;
    VL_TOTAL: string;
    VL_FRANQUIA: string;
    VLR_COMISSAO: string;
    IDS_TIPOS_FORMA_PAGAMENTO: {
        BOLETO: Array<number>;
        BOLETO_ELETRONICO: Array<number>;
        CARTAO: Array<number>;
        DEBITO: Array<number>;
        PIX: Array<number>;
    },
    FL_DOMICILIAR: boolean;
}

export type ParamsBodyFilterPostUpdateQuote = {
    CD_COTACAO: number;
    CD_PESSOA_PARCEIRO: number;
    CD_PESSOA_PARCEIRO_ESTABELECIMENTO: number;
    CD_PESSOA_VENDEDOR: number;
    CD_CANAL_VENDA: number;
}

export type ParamsBodyPostCreateOrder = {
    PRODUTO_ITEM_ESCOLHIDOS: Array<
        {
            TIPO_COBRANCA_DESCONTO: Array<any>;
            CD_COTACAO_ITEM: number;
            VL_COMISSAO: number;
        }
    >;
    FORMA_PAGAMENTO_COBRANCAS: [
        {
            CD_TIPO_FORMA_PAGAMENTO_ESCOLHIDA: number;
            CD_FORMA_PAGAMENTO: number;
            AGENCIA: string | null;
            CONTA: string | null;
            DIGITO_CONTA: string | null;
            NR_RAZAO: null,
            NR_MESES_RECORRENCIA: number;
        }
    ] | [],
    FL_DOMICILIAR: boolean;
    FL_PROCESS_URA: boolean;
    SISTEMA_ENUM: number;
    SOMENTE_LINK_EMAIL: boolean;
    GUID_COTACAO: string;
    CD_CANAL_VENDA: number;
    CD_PESSOA_PARCEIRO: number;
    CD_PESSOA_PARCEIRO_ESTABELECIMENTO: number;
}

export type ParamsDataPostCreateOrder = {
    CD_COTACAO: number;
    CD_PEDIDO: number;
}

export type ParamsDataListaCotacaoAddService = {
    CD_CANAL_VENDA: number;
    CD_COTACAO: number;
    CD_LEAD: string;
    CD_MODELO: number;
    CD_PESSOA_MULTICALCULO: number;
    CD_PESSOA_PARCEIRO: number;
    CD_PESSOA_PARCEIRO_ESTABELECIMENTO: number;
    CD_PESSOA_RESPONSAVEL: number;
    CD_PESSOA_VENDEDOR: number;
    CD_SISTEMA: number;
    CD_TIPO_COMERCIALIZACAO: number;
    COTACAO_ITEM: Array<{
        CAMPANHAS_ELETIVAS_COTACAO_ITEM: Array<any>;
        CD_COTACAO: number;
        CD_COTACAO_ITEM: number;
        CD_LISTA_PRECO: number;
        CD_PRODUTO: number;
        COTACAO_ITEM_SEGURADORA: Array<any>;
        FL_DOMICILIAR: boolean;
        FL_ESCOLHIDO: boolean;
        NR_MESES_RECORRENCIA: number;
        NR_PESO_ESCOLHA: number;
        NR_PORCENTAGEM_INDENIZACAO: number;
        VL_COMISSAO_ADICIONAL: number;
        VL_COMISSAO_ADICIONAL_IMPOSTO: number;
        VL_COMISSAO_MAXIMO: number;
        VL_COMISSAO_MINIMO: number;
        VL_DESCONTO: number;
        VL_ITURAN: number;
        VL_MIN_CAMPANHA: number;
        VL_PROPOSTA: number;
        VL_TOTAL: number;
        VL_TOTAL_DESLOCAMENTO: number;
        VL_TOTAL_SEM_COMISSAO: number;
    }>
    DS_CHASSI: string;
    DS_COMBUSTIVEL: string;
    DS_COR: string;
    DS_PERFIL: Array<{
        Key: string;
        Value: string;
    }>
    DS_PLACA: string;
    DT_COTACAO: string;
    DT_VALIDADE: string;
    GUID_COTACAO: string;
    NR_ANO: number;
    CD_PESSOA_ORIGEM: number;
    NR_ANO_FABRICACAO: number;
    NR_CEP_PERNOITE: string;
    NR_CPF_CNPJ: string;
    NR_PLATAFORMA_ORIGEM: number;
    NR_PORCENTAGEM_COMISSAO: number;
    NR_TIPO_COTACAO: number;
    NR_VERSAO_PERFIL: number;
    STATUS_PEDIDO_COTACAO: number;
    VL_FIPE: number;
}

export type ParamsDataActiveProduct = {
    CD_PEDIDO: number;
    CD_PRODUTO: number;
    DS_TITULO_SITE: string;
    NM_PRODUTO: string;
    NR_TIPO_PRODUTO: number;
}

export type ParamsProducAddTemplate = {
    NM_PRODUTO: string;
    CD_PRODUTO: number;
    NM_TITULO: string;
    DS_PRODUTO: Array<{
        DS_COBERTURA: Array<string>;
    }>;
}

export type ParamsBodyUpdatePersonalData = {
    body: ParamsDataSearchPersonal;
    token: string;
    tokenSent: string;
}

export type ParamsDataUpdatePersonalData = {
    Name: string;
    Value: string;
    ResourceNotFound: false;
    SearchedLocation: string;
    token: string;
}

export type ParamsBodyValidatePersonalData = {
    body: ParamsDataSearchPersonal;
    token: string;
}

export type ParamsDataValidatePersonalData = {
    mensagem: Array<{
        ComunicacaoEnviada: boolean;
        DsErroRetornado: string;
        TipoComunicacaoEnum: number;
    }>
}

export type ParamsBodySearchPersonal = {
    token: string;
    person: string;
    schedule: string;
}

export type RegistrationValidation = {
    FL_AGENDAMENTO_FINALIZADO: boolean;
    FL_VALIDACAO_REALIZADA: boolean;
    PESSOA?: ParamsDataSearchPersonal;
};

export type ParamsDataSearchPersonal = {
    CD_PESSOA: number;
    CD_AGENDAMENTO: number;
    NM_PESSOA: string;
    DS_EMAIL: string;
    Telefone: ParamsDataPhone;
    Endereco: ParamsDataAddress;
    NR_CNPJ_CPF?: string;
    DT_NASCIMENTO?: string;
    NR_TOKEN?: number;
    CD_TIPO_PESSOA: number;
    DS_PLATAFORMA?: string;
};

export type ParamsDataAddress = {
    CD_PESSOA_ENDERECO: number;
    CD_TIPO_LOGRADOURO: string; //Rua
    CD_UF: string;
    DS_COMPLEMENTO: string | null;
    NM_BAIRRO: string | null;
    NM_CIDADE: string;
    NM_ENDERECO: string | null;
    NR_CEP: string | null;
    NR_NUMERO: number;
};

export type ParamsDataPhone = {
    CD_PESSOA_TELEFONE: number;
    NR_DDD: string;
    NR_TELEFONE: string;
    DT_ALTERACAO: string;
};